<div class="gateway-container">
  <div>
    <span class="gateway-title">
      Gateway
    </span>
    <span>
      <button class="btn btn-outline-primary" (click)="createGatewayOrder()">CREATE</button>
    </span>
  </div>

  @if (filterForm) {
    <form [formGroup]="filterForm">
      <div class="gateway-filter-container">
        <input class="form-control" type="search" formControlName="imei"
               placeholder="Search for gateway orders containing IMEI.">
      </div>
    </form>
  }

  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
    <ng-container matColumnDef="gatewayOrderId">
      <th mat-header-cell *matHeaderCellDef>ID</th>
      <td mat-cell class="white-cell" *matCellDef="let gatewayOrder">
        {{gatewayOrder.gatewayOrderId}}
      </td>
    </ng-container>

    <ng-container matColumnDef="orderName">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell class="white-cell" *matCellDef="let gatewayOrder">
        {{gatewayOrder.orderName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="gatewayOrderType">
      <th mat-header-cell *matHeaderCellDef>Type</th>
      <td mat-cell class="white-cell" *matCellDef="let gatewayOrder">
        {{gatewayOrder.gatewayOrderType}}
      </td>
    </ng-container>

    <ng-container matColumnDef="environmentKey">
      <th mat-header-cell *matHeaderCellDef>Environment</th>
      <td mat-cell class="white-cell" *matCellDef="let gatewayOrder">
        {{gatewayOrder.environmentKey}}
      </td>
    </ng-container>

    <ng-container matColumnDef="creatorEmail">
      <th mat-header-cell *matHeaderCellDef>Creator</th>
      <td mat-cell class="white-cell" *matCellDef="let gatewayOrder">
        {{gatewayOrder.creatorEmail}}
      </td>
    </ng-container>

    <ng-container matColumnDef="createdDateTime">
      <th mat-header-cell *matHeaderCellDef>Created</th>
      <td mat-cell class="white-cell" *matCellDef="let gatewayOrder">
        {{gatewayOrder.createdDateTime}}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="gateway-order-row" (click)="goToGatewayOrder(row)"></tr>
  </table>
</div>
